import mixitup from 'mixitup';
import debounce from 'lodash.debounce';
import mixitupMultifilter from '../vendor/mixitup-multifilter';

export default class TrainingFilter {
	constructor($trainingfilter) {

		this.filterContainer = $trainingfilter;
		this.cardsContainer = document.querySelector('[data-training-container]');
		this.fieldGroups = document.querySelectorAll('[data-filtergroup]');
		this.sortBtn = document.querySelector('[data-sort]');
		this.selectBtns = document.querySelectorAll('[data-filter-select]');
		this.initialState = true;
		this.originalCollection = this.cardsContainer.querySelectorAll('.c-trainingcard');

		this.resetBtns = document.querySelectorAll('[data-reset-filter]');

		this.resetBtns.forEach((btn) => {
			btn.addEventListener('click', this.resetFilters.bind(this));
		});

		this.selectBtns.forEach((btn) => {
			btn.addEventListener('change', (e) => {
				this.changedSelect(btn);
			});
		});

		this.searchInput = this.filterContainer.querySelector('[data-search-training]');

		this.searchInput.addEventListener('keyup', debounce(this.filter.bind(this), 300));

		this.filterContainer.addEventListener('change', this.filter.bind(this));

		this.filterContainer.addEventListener('submit', (e) => {
			e.preventDefault();
			this.filter();
		});

		this.sortBtn.addEventListener('change', this.sort.bind(this));

		mixitup.use(mixitupMultifilter);

		this.mixer = mixitup(this.cardsContainer, {
			selectors: {
				target: '.c-trainingcard',
			},
			animation: {
				duration: 400,
				queueLimit: 5,
				effects: 'fade translateY(100px)',
			},
			multifilter: {
				enable: true,
			},

			load: {
				filter: 'none',
			},
		});

		this.filter(true);
	}

	resetFilters() {

		this.filterContainer.querySelectorAll('select').forEach((select) => {
			select.selectedIndex = 0;
		});

		this.selectBtns.forEach((btn) => {
			btn.parentElement.classList.remove('has-value');
		});

		this.searchInput.value = '';

		this.filter(true)
	}

	filter(interaction = true) {
		if (interaction) {
			this.initialState = false;
		}

		let checkedValuesInFieldgroups = [];
		this.fieldGroups.forEach((el) => {
			const checkedInputs = el.querySelectorAll(':checked');
			let checkedValues = '';

			if (checkedInputs.length > 1) {
				checkedValues = [];
			}

			checkedInputs.forEach(element => {
				if (checkedInputs.length > 1) {
					if (element.value !== '') {
						checkedValues.push(element.value);
					}
				} else {
					if (element.value !== '') {
						checkedValues = element.value;
					}
				}
			});

			if (checkedValues !== '') {
				checkedValuesInFieldgroups.push(checkedValues)
			}
		});

		this.filteredCollection = [...this.originalCollection];
		if (checkedValuesInFieldgroups.length > 0) {
			this.filteredCollection = this.filteredCollection.filter((card) => {
				let include = true;
				let shouldInclude = true;
				// debugger;
				checkedValuesInFieldgroups.forEach(values => {
					if (Array.isArray(values)) {
						shouldInclude = include;
						values.some(value => {
							include = shouldInclude && card.classList.contains(value);

							if (include) {
								return include;
							}
						});

						return;
					}

					include = include && card.classList.contains(values);
				});

				return include;
			});
		}

		// if there is a search input you add a new value to the collection
		if(this.searchInput.value && this.filteredCollection) {

			this.filteredCollection = this.filteredCollection.filter(card => {

				const cardTitle = card.querySelector('.c-trainingcard__title');

				const title = cardTitle.textContent.toLowerCase();

				if(title.includes(this.searchInput.value.toLowerCase())) {
					return true;
				}
			});
		}

		this.mixer.filter(this.filteredCollection);

		let itemCount = this.filteredCollection.length;
		let titleEl = document.getElementById('counter');
		this.failMessage = document.querySelector('[data-fail-message]');

		if (itemCount <= 0) {
			titleEl.innerHTML = '';
			this.failMessage.style.display = 'block';
		} else {
			titleEl.innerHTML = `(${itemCount})`;
			this.failMessage.style.display = 'none';
		}
	}

	sort() {
		this.mixer.sort(`${this.sortBtn.value}:asc`).then(function(state) {
			console.log(state.activeSort.sortString); // 'price:desc'
		});
	}

	changedSelect(btn) {
		btn.parentElement.classList.remove('has-value');
		if (btn.value !== '') {
			btn.parentElement.classList.add('has-value');
		}
	}
}
